import _ from "lib/underscore";
import {BaseList} from "./lists";
import {Settings} from "./settings";
import * as urlUtils from "../../../../core/utils/url";
import {debugInfo, settings} from "../data";

export class ReviewList extends BaseList {
	/**
	 * @param {Settings} settings
	 */
	constructor(settings) {
		super({name: 'reviews', settings});
	}

	initData(data) {
		if (settings.debug && _.isObject(data['scores']) && _.isArray(data['items'])) {
			const newItems = _.map(data['items'], item => ({
				...item,
				score: data['scores'][item['id']]
			}));
			data = {
				...data,
				items: newItems
			};
		}
		super.initData(data);
	}

	newItem(itemData) {
		return new ReviewItem(itemData, this.settings);
	}
}

export class ReviewItem {
	/**
	 * @param {object} data
	 * @param {Settings} settings
	 */
	constructor(data, settings) {
		this.id = data.id;
		this.text = data.text;
		this.authorId = data.authorId;
		this.authorName = data.authorName;
		this.previewImage = data.previewImage ? urlUtils.siteUrl(data.previewImage) : urlUtils.siteUrl('public/images/noimage.png');
		this.productName = data.productName;
		this.shopName = data.shopName;
		this.shopSlug = data.shopSlug;
		this.price = settings.convertPrice(data.price);
		this.rating = data.rating;
		this.likesCount = data.likesCount;
		this.commentsCount = data.commentsCount;
		this.date = new Date(data.date);
		this.score = data.score;
	}

	get authorUrl() {
		return urlUtils.siteUrl('users', this.authorId);
	}

	get shopUrl() {
		return urlUtils.siteUrl('shops', this.shopSlug);
	}

	get url() {
		return urlUtils.siteUrl('reviews', 'id' + this.id);
	}

	showDebugInfo() {
		if (settings.debug && this.score) {
			debugInfo.show('review', this.id);
		}
	}
}



// WEBPACK FOOTER //
// ./modules/shop/common/model/reviews.js